import React from "react";
import ReactECharts from "echarts-for-react";

const AreaChart = ({ chart }) => {

  const option = {

    tooltip: {
      trigger: "axis",
    },

    xAxis: {
      type: "category",
      data: chart.data.map((item) => item.name),
    },

    yAxis: {
      type: "value",
    },

    series: [
      {
        type: "line",

        smooth: true,

        areaStyle: {},

        data: chart.data.map((item) => item.value),
      },
    ],
  };

  return (
    <ReactECharts
      option={option}
      style={{ height: 350 }}
    />
  );
};

export default AreaChart;